// extracted by mini-css-extract-plugin
module.exports = {"asideItem":"AsideItem_asideItem__1dQTx","anchor":"AsideItem_anchor__2fJxO","isActivated":"AsideItem_isActivated__1apcg"};